import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import StepHeader from './StepHeader';
import AlertDismissable from './Alert';
import VerificationInput from 'react-verification-input';
import axios from 'components/AppRequest';
import mergeErrors from 'components/helpers/mergeErrors';
import withRouter from 'components/components/common/withRouter';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import { connect } from 'react-redux';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import AppLink from 'components/common/AppLink';

class VerificationPhoneNumber extends Component {

  state = {
    redirect: false,
    inputValue: '',
    isLoading: false
  }

  trans = (key, prefix = "content.common") => {
    return TransHelper.translate(this.props.locale, prefix + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.phoneNumberVerification');
  }

  createAccountRequest = () => {
    this.setState({ isLoading: true }, () => {
      if (this.validInput.state.tan.length === 4) {
        const { email, name, phone, password,
          phoneCountry, token, profile_id, type } = this.props.customerData
        var wholePhone = phoneCountry.label + phone;
        var params = {
          data: {
            token,
            profile_id,
            type,
            verification_code: this.validInput.state.tan,
            customer: {
              name,
              email,
              phone: wholePhone,
              password,
              language: this.props.locale
            }
          }
        };

        axios.post('/pwa/registration/create-account', params)
          .then(response => {
            LocalStorageHelper.saveToken(response.data.token);
            this.props.setUserLogged(response.data);
            if (this.props.isBooking) {
              this.props.createSuccessNotification({
                message: this.transNotify('success')
              });
              TransHelper.redirect(this.props, 'routes.url.summary');
            } else {
              this.props.resetRegisterFields();
              TransHelper.redirect(this.props, 'routes.url.dashboard');
            }
          })
          .catch(err => {
            console.log("err", err);
            this.props.createErrorNotification({
              title: this.transNotify('error'),
              message: mergeErrors(err.response.data.errors)
            });
            this.setState({ isLoading: false });
          });
      } else {
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: this.transNotify('invalidMessage')
        });
        this.setState({ isLoading: false });
      }
    });
  }

  submitForm = (e) => {
    e.preventDefault();
    this.createAccountRequest();
  }

  resendVerificationCode = (e) => {
    e.preventDefault();
    this.setState(
      { isLoading: true },
      () => {
        const { email } = this.props.customerData;
        axios.post('/pwa/registration/resend-verification-code', { email: email })
          .then(response => {
            this.setState({ isLoading: false });
          })
          .catch(err => {
            console.log("err", err.response)
            this.props.createErrorNotification({
              title: this.transNotify('error'),
              message: mergeErrors(err.response.data.errors)
            });
            this.setState({ isLoading: false });
          });
      });
  }

  getLinkToChangePhone = () => {
    if (this.props.isBooking) {
      return 'routes.url.userData';
    } else {
      return 'routes.url.registrationStep1';
    }
  }

  skipCreateAccount = (e) => {
    e.preventDefault();
    this.props.setBookingUserData("createAccountWithBooking", false);
    TransHelper.redirect(this.props, 'routes.url.summary');
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    const { isLoading } = this.state;
    return (
      <Fragment>
        <div className="layout layout--bg-corner">
          <div className="wrapper">
            {!this.props.isBooking &&
              <StepHeader
                link={this.getLinkToChangePhone()}
                linkTitle={this.trans('headerLinkTitle')}
                step={2}
                maxSteps={2}
                title={this.t('content.auth.registrationFormStep3.headerTitle')}
              />
            }
            <div className="content">

              <p className="text-center mb-5">
                <T variables={{
                  "email": this.props.customerData.email
                }}>
                  content.auth.registrationFormStep3.headerDescription
                </T>
              </p>

              <p className="text-center mb-25">
                <T>content.auth.registrationFormStep3.wrongQuestion</T>{' '}
                <AppLink to={this.getLinkToChangePhone()} title={this.trans('changeTitle')}>
                  <T>content.auth.registrationFormStep3.change</T>
                </AppLink>
              </p>

              <form>
                <fieldset>
                  <legend className="visuallyhidden">Code Verification Form</legend>

                  <VerificationInput
                    autoFocus={true}
                    debug={false}
                    length={4}
                    placeholder=" "
                    removeDefaultStyles
                    //container={{
                    //  className: 'container',
                    //}}
                    characters={{
                      className: 'characters',
                    }}
                    character={{
                      className: 'character',
                      classNameInactive: 'character--disabled',
                      classNameSelected: 'character--selected',
                      type: 'number-pad',
                      inputMode: 'numeric',
                    }}
                    validChars="0-9"
                    inputField={{
                      inputMode: 'numeric',
                      type: 'number-pad',
                    }}
                    ref={ref => this.validInput = ref}
                  />

                  <p className="text-center mb-30" onClick={this.resendVerificationCode}>
                    <T>content.auth.registrationFormStep3.receiveCodeQuestion</T><br />
                    <a href="">
                      <T>content.auth.registrationFormStep3.sendAgain</T>
                    </a>

                    {this.props.isBooking &&
                      <Fragment>
                        &nbsp;
                        <T>content.auth.registrationFormStep3.separator</T>
                        <a href="" onClick={this.skipCreateAccount} title={this.trans('skipTitle')}>
                          <T>content.auth.registrationFormStep3.skip</T>
                        </a>
                      </Fragment>
                    }
                  </p>

                  {isLoading
                    ?
                    <LoadingSpinner className="button button--expand" />
                    :
                    <button
                      className="button button--expand"
                      onClick={this.submitForm}
                    >
                      <T>content.auth.registrationFormStep3.done</T>
                    </button>
                  }
                </fieldset>
              </form>
            </div>
          </div>

        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { createSuccessNotification, createErrorNotification }
  )(VerificationPhoneNumber)
);
